export const getCurrentHostAndProtocol = (): string => window.location.origin;
